import { API_URL } from '../../const'
// A bare 'http' resolves to Node's built-in module in Jest, not this project's client.
import http from '../../http'
import { IEndOfLifeMutation } from './types'

const END_OF_LIFE_URL: string = `${API_URL}/EndOfLife`

export const getEndOfLife = (itemId: string) => http.get(`${END_OF_LIFE_URL}/${itemId}`)

export const updateEndOfLife = (itemId: string, data: IEndOfLifeMutation) =>
  http.put(`${END_OF_LIFE_URL}/${itemId}`, { data })

export const createEndOfLife = (data: IEndOfLifeMutation) =>
  http.post(`${END_OF_LIFE_URL}`, { data })

export const deleteEndOfLife = (itemId: string) => http.delete(`${END_OF_LIFE_URL}/${itemId}`)

export const publishEndOfLife = (itemId: string) =>
  http.post(`${END_OF_LIFE_URL}/publish/${itemId}`)

// Capital P, as the controller declares it.
export const unPublishEndOfLife = (itemId: string) =>
  http.delete(`${END_OF_LIFE_URL}/unPublish/${itemId}`)

// The material taxonomy arrives on this payload, so the Product select needs no second call.
export const getEndOfLifeConfiguration = () => http.get(`${END_OF_LIFE_URL}/configuration`)
